import 'angular';
import '../../../../lib/assets/javascripts/devex/util';

angular.module('filters.formatDate', [])
  .filter('formatDate', function () {
    return function(date) {
      return devex.util.formatDate(date);
    };
  });
